<template>
  <section>
    <div class="row justify-content-center" v-if="loading">
      <loading />
    </div>
    <div class="row" v-else>
      <div
        class="col-sm-6 col-md-4 col-lg-3"
        v-for="(produto, key) in produtos"
        :key="key"
      >
        <router-link
          class="text-center bg-white d-flex flex-column justify-content-center align-content-center pt-4 pb-5 mt-4 text-primary rounded"
          :to="produto.link"
        >
          <div><i class="material-icons text-warning">groups</i></div>
          <div class="font-weight-bold mt-2 h5">{{ produto.nome }}</div>
          <div class="text-dark mt-2" v-if="produto.valor">
            {{ produto.valor | currency }}
          </div>
        </router-link>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "ClubeVantagens",
  data() {
    return {
      produto: {
        nome: "Clube de Vantagens",
        id: "clube-painel",
      },
      breadcrumb: [
        {
          nome: "Clube de Vantagens",
          id: "clube-painel",
        },
      ],
      produtos: [],
      loading: true,
      comprarClube: false,
      assinarTermo: false,
    };
  },
  methods: {},
  created() {
    sessionStorage.removeItem("reserva");
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.$http
      .get("/api/Clube/ConsultarClubeVantagens")
      .then((response) => {
        if (!response.data.status) {
          this.comprarClube = true;
          this.produtos = [
            {
              nome: "Adquirir Clube de Vantagens",
              valor: 120.0,
              link: "formulario/clube/",
            },
          ];
        } else if (!response.data.termoAssinado) {
          this.assinarTermo = true;
          this.produtos = [{ nome: "Assinar Termo", link: "termo" }];
        }
      })
      .catch((error) => {
        console.log(error.response);
        if (error.response.status === 400) {
          this.produtos = [
            {
              nome: "Adquirir Clube de Vantagens",
              valor: 120.0,
              link: "/produto/clube-vantagens/termo",
            },
          ];
        }
        if (error.statusCode === 401) {
          this.$router.push({ name: "login" });
        }

        this.loading = false;
        this.error = error.response.data.mensagem;
      });
    /*this.$http
      .get("/api/Agenda/ListarAgendas")
      .then((response) => {
        var link = "";
        var valores = [];
        response.data.forEach((produto) => {
          if (produto.espaco.match(/SALA/)) {
            link = "formulario/reuniao/" + produto.agendaId;
          } else if (produto.espaco.match(/ROOFTOP/)) {
            link = "formulario/rooftop/" + produto.agendaId;
          } else if (produto.espaco == "ESTAÇÃO DE TRABALHO") {
            link = "estacao-trabalho/" + produto.agendaId;
          } else if (produto.espaco === "ESCRITÓRIO VIRTUAL") {
            link =
              "formulario-estacao-trabalho/" +
              produto.agendaId +
              "/escritorio-virtual";
          }

          const dadosProduto = {
            nome: produto.espaco,
            capacidade: produto.capacidade,
            valor: produto.valorComDesconto
              ? produto.valorComDesconto
              : produto.valor,
            tipoValor: produto.tipoValor,
            link: link,
          };

          this.produtos.push(dadosProduto);
          valores.push({
            agendaId: produto.agendaId,
            valor: produto.valorComDesconto
              ? produto.valorComDesconto
              : produto.valor,
            capacidade: produto.capacidade,
          });
        });

        this.loading = false;
        sessionStorage.setItem("valoresProdutos", JSON.stringify(valores));
      })
      .catch((error) => {
        if (error.statusCode === 401) {
          this.$router.push({ name: "login" });
        }

        this.loading = false;
        this.error = error.response.data.mensagem;
      });*/
    /*this.produtos = [
      { nome: "Anúncio + Clube", valor: 120.0, link: "formulario/anuncio/" },
      {
        nome: "Usuários + Clube",
        valor: 100.0,
        link: "formulario/usuarios/",
      },
      {
        nome: "Somente Clube",
        valor: 80.0,
        link: "formulario/clube/",
      },
    ];*/
    this.loading = false;
  },
  filters: {
    currency(valor) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return formatter.format(valor);
    },
  },
};
</script>

<style lang="scss" scoped>
.material-icons {
  font-size: 42px;
}
</style>
